import posthog from "posthog-js";
import {
  getPostHogProjectToken,
  isPostHogClientConfigured,
} from "@/lib/analytics/posthog-env";

let missingClientConfigWarningLogged = false;

/**
 * Browser PostHog init (Next instrumentation-client).
 *
 * - Events go through `/ingest` (next.config rewrites → PostHog US).
 * - Surveys stay off. Session replay: D8 Option C — keep
 *   `disable_session_recording: true` here; `PostHogSessionReplayGate` starts
 *   recording only on allowlisted routes (home, market, sell, item/checkout,
 *   profile, my-items, auth, admin products). Clarity remains for heatmaps /
 *   broad replay.
 * - Dev skips remote dependency scripts (Electron/Cursor + adblock often break
 *   them even when `/ingest/static/*` returns 200). Core capture still works;
 *   recorder scripts load in prod via `/ingest`.
 * - Prod loads exception autocapture + web vitals via the same `/ingest` proxy.
 */
if (isPostHogClientConfigured()) {
  const isDev = process.env.NODE_ENV === "development";
  const debug = isDev && process.env.NEXT_PUBLIC_POSTHOG_DEBUG === "true";

  posthog.init(getPostHogProjectToken()!, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    // Force static assets (recorder, exception autocapture, etc.) through the proxy.
    asset_host: "/ingest",
    defaults: "2026-01-30",
    // Prefer versioned /static/<ver>/… paths; fall back to legacy ?v= URLs.
    strict_script_versioning: true,
    disable_surveys: true,
    disable_session_recording: true,
    capture_exceptions: !isDev,
    capture_performance: !isDev,
    // Local: do not inject remote feature scripts (surveys/recorder/exceptions/…).
    disable_external_dependency_loading: isDev,
    debug,
  });
} else if (!missingClientConfigWarningLogged) {
  missingClientConfigWarningLogged = true;
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      "[posthog] Client analytics disabled — set NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN (Admin → Settings → Integrations).",
    );
  }
}
